import './index.less';

import classNames from 'classnames';
import { FC, lazy, Suspense } from 'react';
import { useNavigate } from 'react-router-dom';

import { useI18nContext } from '@/i18n/I18n';
import { isMobile } from '@/utils/ua';

const ProofOfReserveContent = lazy(
  () => import('./comps/ProofOfReserveContent'),
);
const ProofOfReserveHeader = lazy(() => import('./comps/ProofOfReserveHeader'));
const ViewMore = lazy(() => import('./comps/ViewMore'));

const PorContainer: FC = () => {
  const [$t, language] = useI18nContext();
  const navigate = useNavigate();

  return (
    <div
      className={classNames(
        isMobile() ? 'proofH5Page' : 'proofPcPage',
        `page-${language}`,
      )}
    >
      <ProofOfReserveHeader $t={$t} navigate={navigate} isMobile={isMobile()} />
      <Suspense fallback="">
        <ProofOfReserveContent
          $t={$t}
          language={language}
          navigate={navigate}
        />
        <ViewMore $t={$t} language={language} navigate={navigate} />
      </Suspense>
    </div>
  );
};

export default PorContainer;
